// extracted by mini-css-extract-plugin
export default {"man":"man_man__OkrpB","icon":"man_icon__z5VrP","negative":"man_negative__9L3oG"};